import { searchHistoryStyles as historyStyle } from "@insite/content-library/Widgets/Header/SearchHistory";
import { searchInputStyles as inputStyle } from "@insite/content-library/Widgets/Header/SearchInput";
import { StyledButton } from "@insite/mobius/Clickable";
import { StyledTypography } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

if (inputStyle.input) {
    inputStyle.input.cssOverrides = {
        ...inputStyle.input?.cssOverrides,
        formField: css`
            ${inputStyle.input?.cssOverrides?.formField}

            ${mediaQueriesBP.minMD} {
                width: 400px;
            }
        `,
    };

    inputStyle.input.iconProps = {
        ...inputStyle.input.iconProps,
        mergeCss: true,
        color: colorStrings.commonGlobalWhite,
        size: 20,
        css: css`
            &&& {
                background-color: ${getColor(colorStrings.secondaryMain)};
                border-radius: 0;
                padding: 10px;
                top: 0;
                right: 0;
                width: 40px;
                height: 40px;

                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        `,
    };

    inputStyle.input.sizeVariant = "small";
}

inputStyle.autocompleteWrapper = {
    css: css`
        ${inputStyle.autocompleteWrapper?.css}
        ${mediaQueriesBP.minLG} {
            width: 750px;
        }
    `,
};

inputStyle.autocompleteColumnWrapper = {
    css: css`
        ${inputStyle.autocompleteColumnWrapper?.css}
        ${mediaQueriesBP.minLG} {
            &:first-child {
                width: 35%;
            }

            &:last-child {
                width: 65%;
            }
        }
    `,
};

inputStyle.autocompleteProductsStyles = {
    ...inputStyle.autocompleteProductsStyles,
    titleLink: {
        ...inputStyle.autocompleteProductsStyles?.titleLink,
        css: css`
            ${inputStyle.autocompleteProductsStyles?.titleLink?.css}
            ${StyledButton} {
                text-align: left;

                ${StyledTypography} {
                    white-space: normal;
                }
            }
        `,
    },
};

historyStyle.wrapper = {
    ...historyStyle.wrapper,
    css: css`
        ${historyStyle.wrapper?.css}
        ${mediaQueriesBP.minMD} {
            width: 400px;
        }
    `,
};
